<template>
    <ul id="mainMenu" class="menu menu--overflow-y-hidden" @mouseleave="hideAllSubmenus">
        <template v-for="(menuItem, iterate) in Object.values(items)" :key="iterate">
            <template v-if="iterate === 1">
                <li
                    class="menu__item"
                    @mouseover="saleBanners.length ? menuMouseOver($event) : ''"
                    @mouseleave="hideAllSubmenus"
                    @touchstart="saleBanners.length ? menuMouseOver($event) : ''"
                >
                    <div class="menu__bookmark menu__bookmark--sale" :class="{ 'menu__bookmark--sale--hover': !saleBanners.length }">
                        <a
                            class="menu__link menu__link--wrapper menu__link--highlighted"
                            :class="{ 'menu__link--arrow': saleBanners.length }"
                            :href="dictionary.siteHeader.sale.url"
                        >
                            {{ dictionary.siteHeader.sale.title }}
                        </a>
                    </div>
                    <div class="menu__submenu menu__submenu--sale">
                        <div v-if="saleBanners.length" class="menu__submenu--sale-box">
                            <div class="menu__submenu--sale-title">
                                {{ dictionary.siteHeader.sale.title }}
                            </div>
                            <BannersSale :sale-banners="saleBanners" @click-button="hideAllSubmenus" />
                            <div class="menu__submenu--sale-more">
                                <a :href="dictionary.siteHeader.sale.url" class="btn btn-primary py-1 rounded-25 mb-4" @click="hideAllSubmenus">
                                    {{ dictionary.siteHeader.sale.more }}
                                </a>
                            </div>
                        </div>
                    </div>
                </li>
            </template>

            <li
                class="menu__item menu__item--category"
                @mouseover="menuItem.items && menuItem.items.length > 0 ? menuMouseOver($event, menuItem) : hideAllSubmenus()"
            >
                <template v-if="iterate < maxMenuItems">
                    <div
                        class="menu__bookmark"
                        :class="{
                            'menu__bookmark--highlight': xmasCategoryId === menuItem.id,
                            'menu__bookmark--highlight': menuHighlightCategory === menuItem.id,
                        }"
                        @click="hideAllSubmenus"
                    >
                        <!-- Link -->
                        <a
                            @click.prevent="$emit('redirectToUrl', $event)"
                            v-if="isPwa"
                            :class="{
                                menu__link: true,
                                'menu__link--arrow': menuItem.items.length > 0,
                                menu__href: menuItem.items.length === 0,
                                'menu__link--wrapper': xmasCategoryId === menuItem.id || menuHighlightCategory === menuItem.id,
                                'menu__link--special': iterate === 0,
                                'menu__link--highlighted': menuItem.isHighlighted || false,
                            }"
                            :href="menuItem.url"
                        >
                            <span
                                :class="{
                                    'menu__link--highlight menu__link--xmas': xmasCategoryId === menuItem.id,
                                    'menu__link--highlight menu__link--sale': menuHighlightCategory === menuItem.id,
                                }"
                                >{{ menuItem.name }}</span
                            >
                        </a>
                        <a
                            v-else
                            :class="{
                                menu__link: menuItem.items.length > 0,
                                menu__href: menuItem.items.length === 0,
                                'menu__link--wrapper': xmasCategoryId === menuItem.id || menuHighlightCategory === menuItem.id,
                                'menu__link--special': iterate === 0,
                            }"
                            :href="menuItem.url"
                        >
                            <span
                                :class="{
                                    'menu__link--highlight menu__link--xmas': xmasCategoryId === menuItem.id,
                                    'menu__link--highlight menu__link--sale': menuHighlightCategory === menuItem.id,
                                }"
                                >{{ menuItem.name }}</span
                            >
                        </a>
                        <!-- end Link -->
                    </div>
                    <div
                        v-if="menuItem.items.length > 0"
                        class="menu__submenu"
                        :class="{ 'menu__submenu--special': iterate === 0 }"
                        @scroll="showScrollDownSubmenu"
                        @mouseleave="hideAllSubmenus"
                    >
                        <div v-if="iterate === 0" class="menu__special" @click="hideAllSubmenus">
                            <a
                                v-for="(specialMenuItem, specialMenuIndex) in menuItem.items"
                                :key="specialMenuIndex"
                                @click.prevent="$emit('redirectToUrl', $event)"
                                :href="specialMenuItem.url"
                                class="menu__special__item"
                            >
                                <div class="menu__special__image-container">
                                    <img :src="specialMenuItem.cdnImage" />
                                </div>
                                {{ specialMenuItem.name }}
                            </a>
                        </div>
                        <template v-else>
                            <div class="menu__submenu__container" @mouseover.stop>
                                <ul class="menu-second">
                                    <li
                                        v-for="(menuItem1, idx) in menuItem.items"
                                        :key="idx"
                                        class="menu-second__item"
                                        @mouseover.stop="menuMouseOverSubmenu($event, idx)"
                                        @click="setItemActive($event, idx)"
                                    >
                                        <!-- Link -->
                                        <a
                                            @click.prevent="$emit('redirectToUrl', $event)"
                                            v-if="isPwa"
                                            class="menu-second__link with-arrow"
                                            :class="{ 'with-arrow--active': idx === indexL3 }"
                                            :href="menuItem1.url"
                                        >
                                            <!--                                <span class="menu-second__icon">-->
                                            <!--                                    <img-->
                                            <!--                                        v-if="menuItem1.cdnImage"-->
                                            <!--                                        :src="menuItem1.cdnImage"-->
                                            <!--                                        :alt="menuItem1.imageAlt || menuItem1.name"-->
                                            <!--                                        width="22"-->
                                            <!--                                        height="22"-->
                                            <!--                                        loading="lazy"-->
                                            <!--                                    />-->
                                            <!--                                </span>-->
                                            {{ menuItem1.name }}
                                        </a>
                                        <a
                                            v-else
                                            class="menu-second__link with-arrow"
                                            :class="{ 'with-arrow--active': idx === indexL3 }"
                                            :href="menuItem1.url"
                                        >
                                            <!--                                <span class="menu-second__icon">-->
                                            <!--                                    <img-->
                                            <!--                                        v-if="menuItem1.cdnImage"-->
                                            <!--                                        :src="menuItem1.cdnImage"-->
                                            <!--                                        :alt="menuItem1.imageAlt || menuItem1.name"-->
                                            <!--                                        width="22"-->
                                            <!--                                        height="22"-->
                                            <!--                                        loading="lazy"-->
                                            <!--                                    />-->
                                            <!--                                </span>-->
                                            {{ menuItem1.name }}
                                        </a>
                                        <!-- end Link -->
                                    </li>
                                </ul>

                                <div class="menu-second__submenu" @mouseover.stop="submenuDelay">
                                    <ul class="menu-second__subsubmenu" v-if="menuItem.items && menuItem.items[indexL3]">
                                        <li class="showAll" @click="hideAllSubmenus">
                                            <!-- Link -->
                                            <a
                                                @click.prevent="$emit('redirectToUrl', $event)"
                                                v-if="isPwa"
                                                class="goBack menu-second__link text-primary"
                                                :href="menuItem.items[indexL3].url"
                                                >{{ dictionary.siteHeader.seeAllCategory }}
                                                <!--                                    {{ menuItem.items[indexL3].name }}-->
                                            </a>
                                            <a v-else class="goBack menu-second__link text-primary" :href="menuItem.items[indexL3].url"
                                                >{{ dictionary.siteHeader.seeAllCategory }}
                                                <!--                                    {{ menuItem.items[indexL3].name }}-->
                                            </a>
                                            <!-- end Link -->
                                        </li>
                                        <template v-if="menuItem.items[indexL3]">
                                            <li
                                                v-for="(menuItem2, menuItem2Index) in menuItem.items[indexL3].items"
                                                :key="menuItem2Index"
                                                @click="hideAllSubmenus"
                                                class="menu-second__item"
                                            >
                                                <!-- Link -->
                                                <a
                                                    @click.prevent="$emit('redirectToUrl', $event)"
                                                    v-if="isPwa"
                                                    class="menu-second__link"
                                                    :href="menuItem2.url"
                                                    >{{ menuItem2.name }}
                                                </a>
                                                <a v-else class="menu-second__link" :href="menuItem2.url">{{ menuItem2.name }} </a>
                                                <!-- end Link -->
                                            </li>
                                        </template>
                                    </ul>
                                </div>
                                <div></div>

                                <div class="right-section">
                                    <ProductPoster
                                        v-if="menuItemProducts[menuItem.objectId]"
                                        :dictionary="dictionary"
                                        :product="menuItemProducts[menuItem.objectId].product"
                                        :title="menuItemProducts[menuItem.objectId].title"
                                        :is-pwa="isPwa"
                                        :basket-amount="productAmounts[menuItemProducts[menuItem.objectId].product.id] || 0"
                                        @addProductToBasket="addProductToBasket"
                                        @hideMenu="hideAllSubmenus"
                                        @redirectToUrl="redirectToUrl"
                                        @click="hideAllSubmenus"
                                    >
                                        <template v-slot:product="{ product }">
                                            <slot name="product" v-bind="{ product }"></slot>
                                        </template>
                                    </ProductPoster>
                                </div>
                            </div>

                            <div class="brands-section">
                                <BrandsPoster
                                    :dictionary="dictionary"
                                    @hideMenu="hideAllSubmenus"
                                    :menu-banners="menuBanners.filter((item) => item.objectId === menuItem.id)"
                                    :is-pwa="isPwa"
                                    @redirectToUrl="redirectToUrl"
                                />
                            </div>
                        </template>
                    </div>
                </template>
            </li>
        </template>
        <li
            v-if="maxMenuItems < Object.keys(items).length"
            class="menu__item menu__item--simple"
            @mouseover="menuMouseOver($event)"
            @mouseleave="hideAllSubmenus"
        >
            <div class="menu__bookmark">
                <a href="#" class="menu__link menu__link--arrow">
                    {{ dictionary.siteHeader.moreCategories }}
                </a>
            </div>
            <div class="menu__submenu menu__submenu--simple">
                <ul class="menu-second">
                    <template v-for="(menuItem, idx) in items">
                        <li :key="idx" v-if="idx > maxMenuItems - 1" class="menu-second__item" @click="hideAllSubmenus">
                            <!-- Link -->
                            <a @click.prevent="$emit('redirectToUrl', $event)" v-if="isPwa" :href="menuItem.url" class="menu-second__link">
                                {{ menuItem.name }}
                            </a>
                            <a v-else :href="menuItem.url" class="menu-second__link">
                                {{ menuItem.name }}
                            </a>
                            <!-- ende Link -->
                        </li>
                    </template>
                </ul>
            </div>
        </li>

<!--        <li v-if="dictionary.siteHeader.articles" @mouseover="hideAllSubmenus" class="menu__item">-->
<!--            <div class="menu__bookmark">-->
<!--                <a class="menu__link" :href="dictionary.siteHeader.articles.url">-->
<!--                    <span class="menu__link&#45;&#45;articles">-->
<!--                        {{ dictionary.siteHeader.articles.title }}-->
<!--                    </span>-->
<!--                </a>-->
<!--            </div>-->
<!--        </li>-->

        <li v-if="dictionary.siteHeader.counselling" @mouseover="hideAllSubmenus" class="menu__item">
            <div class="menu__bookmark">
                <a class="menu__link" :href="dictionary.url.counselling">
                    <span class="menu__link--articles">
                        {{ dictionary.siteHeader.counselling }}
                    </span>
                </a>
            </div>
        </li>

<!--        <li-->
<!--            v-if="dictionary.siteHeader.brands"-->
<!--            @mouseover="menuBrandBanners.length ? menuMouseOver($event) : ''"-->
<!--            @mouseleave="hideAllSubmenus"-->
<!--            @touchstart="menuBrandBanners.length ? menuMouseOver($event) : ''"-->
<!--            class="menu__item"-->
<!--        >-->
<!--            <div class="menu__bookmark">-->
<!--                <a class="menu__link" :href="dictionary.siteHeader.brands.url">-->
<!--                    <span class="menu__link&#45;&#45;articles">-->
<!--                        {{ dictionary.siteHeader.brands.title }}-->
<!--                    </span>-->
<!--                </a>-->
<!--            </div>-->
<!--            <div class="menu__submenu menu__submenu&#45;&#45;brands">-->
<!--                <div style="width: 100%">-->
<!--                    <BrandsPoster-->
<!--                        :cols="3"-->
<!--                        :dictionary="dictionary"-->
<!--                        @hideMenu="hideAllSubmenus"-->
<!--                        :menu-banners="menuBrandBanners"-->
<!--                        :is-pwa="isPwa"-->
<!--                        @redirectToUrl="redirectToUrl"-->
<!--                    />-->
<!--                    <div class="text-center">-->
<!--                        <a :href="dictionary.siteHeader.brands.url" class="menu__brand-button">{{-->
<!--                            dictionary.siteHeader.brands.showAllBrands-->
<!--                        }}</a>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </li>-->
    </ul>
</template>

<script>
import BrandsPoster from '../elements/BrandsPoster'
import ProductPoster from '../elements/ProductPoster'
import BannersSale from './BannersSale.vue'

const SERVICE_CATEGORY_ID = 6344

export default {
    components: {
        BrandsPoster,
        ProductPoster,
        BannersSale,
    },
    data() {
        return {
            clinicCategoriesId: SERVICE_CATEGORY_ID,
            timeDelay: 300,
            maxMenuItems: 20,
            el: 'a.close',
            indexL3: 0,
            menuHide: null,
        }
    },
    props: {
        productAmounts: {
            type: Object,
            required: false,
            default: () => {},
        },
        isPwa: {
            type: Boolean,
            required: true,
        },
        items: {
            default: false,
            required: true,
        },
        pinnedCategories: {
            default: false,
        },
        menuBanners: {
            default: false,
        },
        menuBrandBanners: {
            type: Array,
        },
        menuItemProducts: {
            default: false,
        },
        xmasCategoryId: {
            type: Number,
            required: false,
        },
        menuHighlightCategory: {
            type: Number,
            required: false,
        },
        dictionary: {
            type: Object,
            required: true,
        },
        saleBanners: {
            type: Array,
            default: null,
        },
    },
    mounted() {
        this.resize()
        window.addEventListener('resize', () => this.resize())
    },
    methods: {
        addProductToBasket(data) {
            this.$emit('addProductToBasket', data)
        },

        redirectToUrl(data) {
            this.$emit('redirectToUrl', data)
        },

        isSubmenuShown(menuItem, submenuItem) {
            return submenuItem.items.length > 0 && menuItem.id !== SERVICE_CATEGORY_ID
        },
        resize() {
            // Start with minimum of 5 items
            this.maxMenuItems = Math.max(1, Object.keys(this.items).length)

            this.$nextTick(function () {
                const mainMenu = document.getElementById('mainMenu')
                if (!mainMenu) {
                    return
                }

                let clientWidth = mainMenu.clientWidth
                let menuWidth = 0

                // Calculate width of non-category items (sale, articles, counselling, brands)
                const nonCategoryItems = [...document.getElementById('mainMenu').querySelectorAll('.menu__item:not(.menu__item--category)')]
                nonCategoryItems.forEach(function (item) {
                    menuWidth += item.offsetWidth + 10 // +10 for gap
                })

                // Test each maxMenuItems value starting from 5
                const totalCategoryItems = Object.keys(this.items).length
                for (let testMaxItems = 1; testMaxItems <= totalCategoryItems; testMaxItems++) {
                    let testMenuWidth = menuWidth

                    // Calculate width of category items up to testMaxItems
                    const items = [...document.getElementById('mainMenu').querySelectorAll('.menu__item.menu__item--category')]
                    for (let i = 0; i < Math.min(testMaxItems, items.length); i++) {
                        if (items[i]) {
                            testMenuWidth += items[i].offsetWidth + 20 // +10 for gap
                        }
                    }

                    // Add estimated width for "more categories" if needed
                    if (testMaxItems < totalCategoryItems) {
                        testMenuWidth += 200 // estimated width for more categories dropdown
                    }

                    if (testMenuWidth < clientWidth) {
                        this.maxMenuItems = testMaxItems
                    } else {
                        break
                    }
                }

                // Ensure minimum of 5 items
                if (this.maxMenuItems < 1) {
                    this.maxMenuItems = 1
                }

                mainMenu.classList.remove('menu--overflow-y-hidden')
            })
        },
        hideAllSubmenus() {
            const menu = document.getElementsByClassName('menu')[0]
            const nav = document.getElementsByClassName('site-header')[0]

            clearTimeout(this.menuShow, this.menuHide)
            this.menuHide = setTimeout(function () {
                menu.classList.remove('menu--opened')
                nav.classList.remove('site-header--open')

                document.querySelectorAll('.menu__submenu').forEach(function (event) {
                    event.classList.remove('menu__submenu--open')
                })

                document.querySelectorAll('.menu__item').forEach(function (event) {
                    event.classList.remove('menu__item--active')
                })
            }, this.timeDelay)
        },
        menuMouseOver(event) {
            event.preventDefault()
            const menuItem = event.currentTarget
            const submenuLink = menuItem.querySelector('.menu__link')
            const nav = document.getElementsByClassName('site-header')[0]
            const menu = document.getElementsByClassName('menu')[0]

            clearTimeout(this.menuShow, this.menuHide)
            this.menuShow = setTimeout(() => {
                // eslint-disable-next-line
                // useNuxtApp().$bus.$emit('menuMouseOver')
                document.querySelectorAll('.menu__item').forEach(function (event) {
                    event.classList.remove('menu__item--active')
                })
                menu.classList.add('menu--opened')
                menuItem.classList.add('menu__item--active')

                if (submenuLink) {
                    submenuLink.classList.add('menu__link--active')
                }

                nav.classList.add('site-header--open')

                // Reset to first item when opening new submenu
                this.indexL3 = 0
            }, this.timeDelay)
        },
        submenuDelay() {
            clearTimeout(this.menuShowSubmenu, this.menuHide)
        },
        setItemActive(event, idx) {
            if (idx >= 0) {
                this.indexL3 = idx
            }
            this.hideAllSubmenus()
        },
        menuMouseOverSubmenu(event, idx) {
            event.preventDefault()
            clearTimeout(this.menuShowSubmenu, this.menuHide)
            this.menuShowSubmenu = setTimeout(() => {
                if (idx >= 0) {
                    this.indexL3 = idx
                }
            }, this.timeDelay)
        },

        scrollDownMenu(event) {
            const arrow = event.currentTarget
            const submenuParent = arrow.parentElement
            submenuParent.scrollBy(0, 500)
            arrow.style.display = 'none'
        },
        showScrollDownSubmenu(e) {
            const submenu = e.target.getElementsByClassName('menu--scroll')[0]
            if (submenu) {
                if (e.target.scrollTop < 10) {
                    submenu.style.display = 'flex'
                } else {
                    submenu.style.display = 'none'
                }
            }
        },
    },
}
</script>

<style lang="scss" scoped>
$menuItemHeight: 46px;

.menu {
    position: relative;
    justify-content: stretch;
    width: 100%;
    padding-left: 0;
    margin-bottom: 0;
    font-size: 14px;
    list-style: none;
    margin-top: 0;
    display: flex;
    gap: 20px;
    flex-wrap: wrap;

    &--overflow-y-hidden {
        overflow-y: hidden;
        max-height: $menuItemHeight;
    }

    a {
        text-decoration: none;
    }

    &::after {
        position: absolute;
        top: calc(100% + 1px);
        right: 0;
        //left: -100%;
        z-index: 0;
        z-index: 0;
        width: 300%;
        height: 100vh;
        visibility: hidden;
        content: '';
        background-color: #000;
        opacity: 0;
        transition: visibility 0s, opacity 150ms ease-in-out;
    }

    &-second {
        position: relative;
        //width: 30%;
        height: auto;
        padding: 32px 0 0 60px;
        //background: #f6f6f6;
        transition: opacity 0.3s ease;
        margin-bottom: 20px;

        &__link {
            position: relative;
            display: flex;
            width: 100%;
            padding: 3px 30px;
            margin-bottom: 2px;
            overflow: hidden;
            line-height: 34px;
            color: #475569;
            text-overflow: ellipsis;
            white-space: nowrap;
            align-items: center;
            justify-content: space-between;
            border-radius: 6px;

            &.with-arrow {
                &:hover,
                &--active {
                    background: #f2f2e9;
                    color: #064740;
                    font-weight: 600;
                    //background: #fff;

                    &:after {
                        content: '';
                        border-left: 2px solid #064740;
                        border-top: 2px solid #064740;
                        border-radius: 2px;
                        width: 10px;
                        height: 10px;
                        display: inline-block;
                        // rotate to right
                        transform: rotate(135deg);

                        //margin-left: 25px;
                    }

                    //&::after {
                    //    position: absolute;
                    //    top: calc(50% - 9px);
                    //    right: 15px;
                    //    display: block;
                    //    width: 15px;
                    //    height: 15px;
                    //    content: '';
                    //    border: solid black;
                    //    border-width: 0 1px 1px 0;
                    //    padding: 5px;
                    //    transform: rotate(-45deg);
                    //    -webkit-transform: rotate(-45deg);
                    //    //background: url('/static/nuxt-assets/images/icons/arrow-menu.svg') no-repeat center center;
                    //}

                    //.menu-second__icon {
                    //    border: 1px solid #c2a4d1;
                    //    background: #f6f6f6;
                    //}
                }
            }

            &:hover,
            &--active {
                background: #f2f2e9;
                color: #064740;
                font-weight: 600;

                &:after {
                    content: '';
                    border-left: 2px solid #064740;
                    border-top: 2px solid #064740;
                    border-radius: 2px;
                    width: 10px;
                    height: 10px;
                    display: inline-block;
                    // rotate to right
                    transform: rotate(135deg);

                    //margin-left: 25px;
                }
            }
        }

        &__item {
            width: 100%;
            list-style-type: none;
        }

        &__icon {
            width: 34px;
            height: 34px;
            border-radius: 100px;
            border: 1px solid #fff;
            margin-right: 14px;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.125s;
            float: left;

            img {
                max-height: 22px;
                max-width: 22px;
                width: auto;
            }
        }

        &__submenu {
            margin-bottom: 20px;

            &--active {
                display: block;
                visibility: visible;
                left: 100%;
                opacity: 1;

                @media (max-width: 980px) {
                    display: block;
                    visibility: visible;
                    opacity: 1;
                    left: 100%;
                    height: 101%;
                    overflow: hidden;
                    overflow-y: auto;
                }
            }

            .menu-second__link {
                line-height: 25px;
                padding: 7px 30px;
            }
        }

        &__subsubmenu {
            background: #f2f2e9;
            border-radius: 16px;
            margin-top: 24px;
            list-style: none;
            padding: 0 0 20px;

            @media (max-width: 980px) {
                padding: 0;
            }

            .showAll {
                font-size: 18px;
                font-weight: 700;
                padding: 20px 0 5px 0;

                a {
                    color: #064740;
                    display: flex;
                    align-items: center;
                    gap: 30px;

                    &:hover {
                        font-weight: 700;
                    }

                    &:after {
                        content: '';
                        border-left: 2px solid #064740;
                        border-top: 2px solid #064740;
                        border-radius: 2px;
                        width: 10px;
                        height: 10px;
                        display: inline-block;
                        // rotate to right
                        transform: rotate(135deg);

                        //margin-left: 25px;
                    }
                }
            }
        }
    }

    &__href {
        position: relative;
        display: flex;
        flex-grow: 1;
        font-size: 14px;
        line-height: $menuItemHeight;
        color: #064740;
        align-self: center;
        text-align: center;
        height: 100%;
        align-items: center;
        justify-content: center;
        padding: 0 12px;
        font-weight: 500;

        &:hover {
            color: #146154;
        }

        &.menu__link--wrapper {
            padding: 0 5px;
        }
    }

    &__submenu {
        position: absolute;
        display: none;
        top: calc(100% + 1px);
        left: -15px;
        width: calc(100% + 15px);
        margin: 0;
        flex-wrap: wrap;
        list-style: none;
        height: 80vh;
        background: #fff;
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
        visibility: hidden;
        z-index: -9;
        transition: opacity 30s ease-in-out;
        padding-bottom: 120px;

        @media (max-width: 980px) {
            width: 100%;
        }

        &--special {
            padding-bottom: 0;
            display: block !important;
            height: auto;
        }

        &__container {
            overflow-y: auto;
            max-height: 80vh;
            display: grid;
            grid-template-columns: 372px 424px 1fr 352px;
            gap: 24px;
            padding-right: 40px;
        }

        &--sale,
        &--highlight {
            height: auto;
        }

        &--sale {
            &-box {
                width: 100%;
            }

            &-title {
                font-weight: 600;
                font-size: 14px;
                line-height: 19px;
                padding: 20px 30px 10px 30px;
            }

            &-more {
                padding: 10px 30px 5px 30px;
                text-align: center;

                .menu__submenu--sale-more-link {
                    text-decoration: underline;

                    &:hover {
                        text-decoration: none;
                    }
                }
            }
        }

        &--simple {
            width: 200px;
            height: auto;
            display: flex;
            background: #fff;
            left: -17px;
            padding-bottom: 0;

            > ul {
                width: 100%;
                padding: 0;
                opacity: 1;
                background: #fff;
                height: auto;
            }

            a {
                &:hover {
                    color: #146154;
                    background: #fff;

                    &:after {
                        border: 0;
                    }
                }
            }

            .menu-second__link {
                line-height: 25px;
                font-weight: 500;
            }
        }

        &__link {
            color: #333333;
            display: inline-block;
            padding: 0 0 1rem;
            font-size: 15px;

            &:hover {
                color: #146154;
            }
        }

        &__image {
            padding: 0.5rem 0 0;
            max-width: 100%;
            max-height: 100px;
        }
    }

    &__link {
        font-size: 15px;
        flex-grow: 1;
        line-height: $menuItemHeight;
        color: #064740;
        display: flex;
        height: 100%;
        align-items: center;
        justify-content: center;
        gap: 10px;
        padding: 0 11px 8px;
        position: relative;
        text-decoration: none;
        font-weight: 500;

        &--special {
            background: #fccce6;
            border-radius: 25px;
            padding: 0 12px 0;
            border-bottom: 0 !important;
            line-height: 32px;
            margin-top: 7px;
        }

        &--highlighted {
            background: #7efd92;
            border-radius: 25px;
            padding: 0 12px 0;
            border-bottom: 0 !important;
            line-height: 32px;
            margin-top: 7px;
        }

        &--arrow {
            &:after {
                position: relative;
                top: -1px;
                height: 8px;
                width: 8px;
                content: '';
                border-top: 2px solid #064740;
                border-left: 2px solid #064740;
                border-right: 0;
                border-bottom: 0;
                transform: rotate(-135deg);
                border-radius: 1px;

                &--all {
                    //top: 44%;
                    //right: 9px;
                }
            }
        }

        //&::before {
        //  position: absolute;
        //  left: 0;
        //  bottom: 0;
        //  content: '';
        //  width: 100%;
        //  height: 35px;
        //  box-shadow: 0 0 4px 3px rgba(0, 0, 0, 0.08);
        //  border-radius: 10px;
        //  transition: height 0.5s linear;
        //  display: none;
        //}

        &.menu__link--wrapper {
            //padding: 5px 5px 0;

            &:after {
                bottom: -16px;
            }

            //&:before {
            //  bottom: -6px;
            //}
        }

        &--sale--hover {
            &:hover {
                background: #146154;
                color: #064740;
            }
        }

        &--blackFriday {
            color: white;
            background: black;
            border-radius: 25px;
            display: flex;
            align-items: center;
            padding: 0 10px 0 5px;
            height: 30px;

            img {
                margin-right: 4px;
                background: white;
            }
        }

        &--christmas {
            color: #146154;

            img {
                margin-right: 4px;
            }
        }

        &--articles {
            &:hover {
                color: #146154;
            }
        }

        &--sale,
        &--highlight {
            color: #064740;
            //border: 1px solid #F2F2E9;
            //border-radius: 15px;
            //padding: 6px 16px 6px 16px;
            padding-right: 10px;
            font-size: 14px;
            line-height: 38px;
            z-index: 104;

            .menu__submenu {
                margin-top: 6px;
            }

            &::before {
                background-color: #fddde2;
                z-index: -1;
            }
        }

        &--highlight {
            position: relative;
            padding: 6px 16px 6px 35px;

            &:before {
                background-size: cover;
                width: 20px;
                height: 20px;
                content: '';
                position: absolute;
                top: 5px;
                left: 11px;
            }
        }

        &--xmas:before {
            background: transparent url('../../icons/xmas.svg') no-repeat scroll 50% 50%;
        }

        &--sale:before {
            background: transparent url('../../icons/sale.svg') no-repeat scroll 50% 50%;
        }
    }

    &__item {
        //flex-grow: 1;
        //display: inline-block;

        &:empty {
            display: none;
        }

        &--right {
            float: right;
            text-transform: uppercase;

            .menu__submenu {
                right: 0;
                left: auto;
            }
        }

        &--simple {
            position: relative;
        }
    }

    &__bookmark {
        &--sale {
            .menu__link {
                //background: #fccce6;
                border-radius: 25px;
                padding: 0 11px 0;
            }
        }
    }

    &--opened {
        &::after {
            visibility: visible;
            opacity: 0.5;
        }

        .menu__item {
            &--active {
                .menu__bookmark {
                    position: relative;

                    &--sale,
                    &--highlight {
                        padding: 0 0 6px 0;
                    }

                    &--highlight .menu__link--wrapper {
                        padding: 6px 5px 0 5px;
                    }

                    &.menu__submenu {
                        height: auto;
                    }
                }

                .menu__link {
                    text-decoration: none;
                    //background: #fccce6;
                    color: #146154;
                    //border-radius: 25px;
                    border-bottom: 2px solid #146154;

                    &::before {
                        display: block;
                        height: $menuItemHeight;
                    }

                    &--arrow {
                        &:after {
                            transform: rotate(45deg);
                            top: 3px;
                        }
                    }
                }

                .menu__submenu--sale,
                .menu__submenu--highlight {
                    height: auto;
                }

                .menu__submenu {
                    //scroll-behavior: smooth;
                    visibility: visible;
                    opacity: 1;
                    z-index: 102;
                    display: grid;
                }
            }
        }
    }

    &-sales {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        padding: 5px 30px 25px 30px;

        &--only-category {
            padding-top: 25px;
        }

        &--link {
            border-radius: 10px;
            margin: 10px 30px 10px 0;
            font-weight: 500;
            font-size: 14px;
            line-height: 19px;
            position: relative;
            width: 270px;
            padding: 14px 17px;

            img {
                margin-right: 15px;
            }

            .svg {
                fill: #fff;
                position: absolute;
                width: 25px;
                height: 25px;
                border-radius: 33px;
                transition: all 0.3s;
                z-index: 5;
                right: 10px;
                background-color: #c2a4d1;
                display: flex;
                align-items: center;
                justify-content: center;
                top: 14px;
                padding: 8px;
            }
        }

        .menu-second__item {
            width: 295px;
        }
    }

    .menu--scroll {
        fill: #fff;
        position: absolute;
        width: 25px;
        height: 25px;
        border-radius: 33px;
        transition: all 0.3s;
        z-index: 5;
        right: 10px;
        background-color: #c2a4d1;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 8px;
        left: 50%;
        bottom: 15px;
        transform: rotate(90deg);
    }

    &__brand-button {
        background: #146154;
        border-radius: 15px;
        padding: 0 15px;
        line-height: 40px;
        color: #fff;
        display: inline-block;
        margin: 10px auto 20px;
    }

    &__special {
        margin: 32px 0 50px 60px;
        display: grid;
        grid-template-columns: 312px 312px;
        column-gap: 136px;
        row-gap: 32px;

        &__image-container {
            width: 56px;
            height: 56px;
            background: #f2f2e9;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 10px;

            img {
                max-height: 44px;
                max-width: 44px;
            }
        }

        &__item {
            display: grid;
            grid-template-columns: 56px 1fr;
            gap: 20px;
            align-items: center;
            font-size: 18px;
            font-weight: 500;
            color: #475569;

            &:hover {
                .menu__special__image-container {
                    background: #e9f8eb;
                }
            }
        }
    }
}

.right-section {
    //position: absolute;
    //top: 0;
    //right: 20px;
    //width: 40%;

    @media (max-width: 980px) {
        width: 30%;
    }
}

.brands-section {
    grid-column: span 3;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
}
</style>
